import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

/** 收货异常记录module name */
export const RejectRecordModule = 'RejectRecord'
/** 摇钱树拒收记录module name */
export const ScwRejectRecordModule = 'RejectRecordMoneyTree'

const vairety: RouteRecordRaw = {
  path: '/supply',
  name: 'Supply',
  redirect: '/supply/record-money-tree',
  component: Layout,
  meta: {
    title: '供货管理',
    icon: 'supply|svg',
    module: 'Supply'
  },
  children: [
    // 入库记录
    {
      path: 'warehouse/records',
      name: 'WarehouseRecords',
      component: () => import('@/views/WarehouseRecords/index.vue'),
      meta: {
        module: 'WAREHOUSE_RECORDS',
        title: '入库记录'
      }
    },
    // 摇钱树供货记录
    {
      path: 'record-money-tree',
      meta: {
        showGuideIcon: true,
        module: 'SupplyRecordMoneyTree'
      },
      children: [
        {
          path: '',
          name: 'SupplyRecordMoneyTree',
          component: () => import('@/views/SupplyRecord/index.vue'),
          meta: {
            title: '摇钱树供货记录',
            module: 'SupplyRecordMoneyTree'
          }
        },
        {
          path: 'drug-test-report',
          name: 'CashCowDrugTestReportChildren',
          component: () =>
            import('@/views/CashCowDrugTestReportNew/cash-cow-drug-test-report-new.vue'),
          meta: {
            title: '摇钱树药检报告',
            breadcrumb: ['摇钱树药检报告'],
            hideInMenu: true,
            hideInTab: true,
            parentMenu: '/supply/record-money-tree',
            replaceBack: true,
            module: 'DrugTestReport'
          }
        }
      ]
    },
    //供货记录 非摇钱树订单
    {
      path: 'record',
      name: 'SupplyRecord',
      component: () => import('@/views/SupplyRecord/index.vue'),
      meta: {
        title: '供货记录',
        showGuideIcon: true,
        module: 'SupplyRecord'
      }
    },
    // 供货记录-非摇钱树订单-待确认订单列表-移动端
    {
      path: 'record/pending/mobile',
      name: 'PendingSupplyOrder',
      component: () => import('@/views/PendingSupplyRecordMobile/index.vue'),
      meta: {
        title: '待确认订单列表',
        module: 'SupplyRecord',
        hideInMenu: true,
        hideInTab: true,
        hideSider: true,
        hideHeader: true,
        hidePageHeader: true,
        setTitle: true,
        fullRedirectPath: true,
        silent: true,
        useModules: ['SupplyRecord']
      }
    },
    {
      path: 'record/pending/products/mobile',
      name: 'PendingSupplyOrderProducts',
      component: () => import('@/views/PendingSupplyOrderProducts/index.vue'),
      meta: {
        title: '商品列表',
        module: 'SupplyRecord',
        hideInMenu: true,
        hideInTab: true,
        hideSider: true,
        hideHeader: true,
        hidePageHeader: true,
        setTitle: true,
        fullRedirectPath: true,
        silent: true,
        useModules: ['SupplyRecord']
      }
    },
    {
      path: 'record/pending/products/reject-detail/mobile',
      name: 'SupplyOrderProductsRejectDetail',
      component: () => import('@/views/PendingSupplyOrderProducts/RejectDetail.vue'),
      meta: {
        title: '拒收详情',
        module: 'SupplyRecord',
        hideInMenu: true,
        hideInTab: true,
        hideSider: true,
        hideHeader: true,
        hidePageHeader: true,
        setTitle: true,
        fullRedirectPath: true,
        silent: true,
        useModules: ['SupplyRecord']
      }
    },
    // 摇钱树拒收记录
    {
      path: 'reject-record-money-tree',
      name: 'RejectRecordMoneyTree',
      component: () => import('@/views/RejectRecord/index.vue'),
      meta: {
        title: '摇钱树拒收记录',
        showGuideIcon: true,
        module: ScwRejectRecordModule,
        useModules: [ScwRejectRecordModule]
      }
    },
    //非摇钱树收货异常记录
    {
      path: 'reject-record',
      name: 'RejectRecord',
      component: () => import('@/views/RejectRecord/index.vue'),
      meta: {
        title: '入库异常反馈',
        menuName: '入库异常反馈',
        showGuideIcon: true,
        module: RejectRecordModule,
        useModules: [RejectRecordModule]
      }
    },
    // 收货异常记录页-移动端
    {
      path: 'reject-record-mobile',
      name: 'RejectRecordMobile',
      component: () => import('@/views/RejectRecordMobile/index.vue'),
      meta: {
        title: '收货异常记录移动端',
        documentTitle: '收货异常记录',
        module: 'REJECT_RECORD_MOBILE',
        hideInMenu: true,
        hideInTab: true,
        hideSider: true,
        hideHeader: true,
        hidePageHeader: true,
        setTitle: true,
        fullRedirectPath: true,
        silent: true,
        isMobilePage: true,
        useModules: [RejectRecordModule, ScwRejectRecordModule]
      }
    },
    //摇钱树药检报告
    {
      path: 'cash-cow-drug-test-report',
      name: 'CashCowDrugTestReport',
      component: () => import('@/views/CashCowDrugTestReportNew/cash-cow-drug-test-report-new.vue'),
      meta: {
        title: '摇钱树药检报告',
        showGuideIcon: true,
        module: 'DrugTestReport'
      }
    },
    //退货记录
    {
      path: 'returns-record',
      name: 'ReturnsRecord',
      component: () => import('@/views/ReturnsRecord/index.vue'),
      meta: {
        title: '退货记录',
        module: 'RETURNS_RECORD'
      }
    }
  ]
}

export default vairety
